import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Profil yalnızca oturum gerektirir (özel izin yok); auth, parent dashboardRoute'un
// `requireAuth` beforeLoad'ından miras alınır.
export const profileRoute = createRoute({
  getParentRoute: () => dashboardRoute,
  path: '/profile',
  head: () => ({ meta: [{ title: 'Profil' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
  component: lazyRouteComponent(
    () => import('@/modules/profile/pages/profile.page')
  ),
})
